import styled from 'styled-components'

interface ContainerProps {
  disabled?: boolean
}

export const Container = styled.div<ContainerProps>`
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  padding: 0 20px;
  background-color: ${({ disabled }) => (disabled ? '#f5f5f5' : '#fff')};
  
  .PhoneInputInput {
    background: transparent !important;
    border: none !important;
    color: #4b4b4b;
    height: 48px;
    margin-left: 2px;

    &::placeholder {
      color: #c4c4c4
    }

    &:focus {
      outline: none;
    }
  }

  .PhoneInputCountryIcon--border {
    border: none !important;
    background-color: transparent !important;
    box-shadow: none !important;
  }

  .PhoneInputCountryFlag-height {
    height: 24px;
  }
`